import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { config } from './../config';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(
    private _http: HttpClient
  ) { }



  getCompetencyDashboardData(data: any): Observable<any> {
    console.log('Adding Jobs', data)
    return new Observable<any>((observer) => {
      console.log("Observable");
      this._http.post(config.baseApiUrl + "analytic/competency", data).subscribe((res: any) => {
        console.log("response of new job created", res);
        observer.next(res);
      }, err => {
        console.log("ERROR");
        observer.error(err.msg);
      }, () => {
        observer.complete()
      })
    })
  }


  getFatigueDashboardData(data: any): Observable<any> {
    console.log('Adding Jobs', data)
    return new Observable<any>((observer) => {
      console.log("Observable");
      this._http.post(config.baseApiUrl + "analytic/fatigue", data).subscribe((res: any) => {
        console.log("response of new job created", res);
        observer.next(res);
      }, err => {
        console.log("ERROR");
        observer.error(err.msg);
      }, () => {
        observer.complete()
      })
    })
  }

  getLiveFatigueScore(dates): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this._http.get(config.baseApiUrl + "analytic/live-fatigue-score?_dates=" + JSON.stringify(dates)).subscribe((res: any) => {
        console.log("response of new job created", res);
        observer.next(res);
      }, err => {
        console.log("ERROR");
        observer.error(err.msg);
      }, () => {
        observer.complete()
      })
    })
  }

}
